import { useEventItem, useMarketItems } from 'modules/common/hooks';
import MojitoPresentation from 'mojito/presentation';
import { useCallback } from 'react';
import PrebuiltBetBuilder from 'modules/prebuilt-bets/prebuilt-bet/bet-builder-view/index.js';
import PrebuiltAcca from 'modules/prebuilt-bets/prebuilt-bet/acca-view/index.js';
import PrebuiltCardTypes from 'modules/prebuilt-bets/types/index.js';

const { IntentActionTrigger } = MojitoPresentation.Base.Intent;
const { PREBUILT_ACCA } = PrebuiltCardTypes.MARKETS;

const PrebuiltBetController = props => {
    const {
        eventId,
        marketId,
        promotionText,
        boostedMarketId,
        shouldRequestData,
        mojitoTools: { config },
    } = props;

    const event = useEventItem(eventId, shouldRequestData);
    const markets = useMarketItems([marketId, boostedMarketId], shouldRequestData);
    const market = markets.find(market => market.id === marketId);
    const boostedMarket = markets.find(market => market.id === boostedMarketId);

    const onEventClick = useCallback(() => {
        IntentActionTrigger.showSportEvent(event.sportId, event.id);
    }, [event?.sportId, event?.id]);

    if (!market || !event) {
        return null;
    }

    if (market.type === PREBUILT_ACCA) {
        return (
            <PrebuiltAcca
                config={config.prebuiltAcca}
                onEventClick={onEventClick}
                market={market}
                event={event}
                promotionText={promotionText}
            />
        );
    }

    return (
        <PrebuiltBetBuilder
            config={config.prebuiltBetBuilder}
            onEventClick={onEventClick}
            market={market}
            boostedMarket={boostedMarket}
            event={event}
            promotionText={promotionText}
        />
    );
};

export default PrebuiltBetController;
